import AddTaskIcon from '@mui/icons-material/AddTask'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { Grid, IconButton, Stack } from '@mui/material'
import SimpleCustomTooltip from 'components/ui/simple-custom-tooltip'
import React from 'react'

const NcoHoverMenu = ({
  addRow,
  setConfirmOpen,
  isLoading,
  isDisabled,
  isDeleting,
}: {
  addRow: () => void
  setConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>
  isLoading: boolean
  isDisabled: boolean
  isDeleting: boolean
}) => {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      className="toolbar-actions"
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        backgroundColor: 'rgba(0,0,0,0.45)',
        backdropFilter: 'blur(4px)',
        borderRadius: '25px',
        px: 0.5,
        py: 0.25,
        boxShadow: 3,
        zIndex: 2,
        opacity: 0, // hidden by default
        transform: 'translateY(-4px)',
        transition: 'opacity .18s ease, transform .18s ease',
        pointerEvents: 'none', // click-through until parent hovered
        minWidth: '15vw',
      }}
    >
      <Grid container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <IconButton onClick={addRow} disabled={isDisabled}>
            <SimpleCustomTooltip title="Add New Task" isLoading={isLoading} placement={'bottom'}>
              <AddTaskIcon sx={{ fontSize: '30px', color: isDisabled ? 'text.secondary' : 'text.highlight' }} />
            </SimpleCustomTooltip>
          </IconButton>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <IconButton onClick={() => setConfirmOpen(true)} disabled={isDeleting || isDisabled}>
            <SimpleCustomTooltip
              title="Delete Current Task List"
              isLoading={isLoading}
              textColor={'text.error'}
              placement={'bottom'}
            >
              <DeleteOutlineIcon sx={{ height: 30, width: 30, color: isDisabled ? 'text.secondary' : 'text.error' }} />
            </SimpleCustomTooltip>
          </IconButton>
        </Grid>
      </Grid>
    </Stack>
  )
}
export default NcoHoverMenu
